var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-calendar-list-item", {
    attrs: {
      name: _vm.folder.Folder.Name,
      color: "#4bd395",
      active: _vm.active,
    },
    on: {
      load: function ($event) {
        return _vm.load()
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }